import React, { createRef } from 'react';
import { createRoot } from 'react-dom/client';
import VersionsDropdown from './VersionsDropdown';
import type { VersionsDropdownProps, VersionsDropdownAPI, VersionsDropdownHandle } from './types';

declare global {
  interface Window {
    mountVersionsDropdown: (containerId: string, props: VersionsDropdownProps) => VersionsDropdownHandle;
  }
}

window.mountVersionsDropdown = function mountVersionsDropdown(
  containerId: string,
  props: VersionsDropdownProps,
): VersionsDropdownHandle {
  const container = document.getElementById(containerId);
  if (!container) {
    console.error('VersionsDropdown: container not found:', containerId);
    return { unmount: () => {}, get api() { return null; } };
  }

  const apiRef = createRef<VersionsDropdownAPI>();
  const root = createRoot(container);
  root.render(React.createElement(VersionsDropdown, { ...props, ref: apiRef }));

  return {
    unmount: () => root.unmount(),
    get api() { return apiRef.current; },
  };
};
